import { TENANT_COM } from 'shared/consts/tenants'

import buildClientAPI from 'views/providers/clientAPI'
import store from 'shared/store'
import { isSaeOnly } from 'shared/experiments/utils'

export default () => {
  const { cartService, clientFockService } = buildClientAPI()

  const DATA_HOOKS = {
    conventionalPrescription: 'conventional-prescription',
    ePrescription: 'e-prescription',
    ePrescriptionInfo: 'e-prescription-info',
    prescriptionInfo: 'prescription-info',
    conventionalPrescriptionInfo: 'conventional-prescription-info',
    differenceLink: 'difference-link'
  }

  const renderModal = response => {
    function getClientSideHook(name) {
      return document.querySelector(`[data-clientside-hook="${name}"]`)
    }

    const rxButton = getClientSideHook(DATA_HOOKS.conventionalPrescription)
    const eRxButton = getClientSideHook(DATA_HOOKS.ePrescription)
    const info = getClientSideHook(DATA_HOOKS.prescriptionInfo)

    if (response.data.hasRxItems) {
      eRxButton.classList.add('a-Button--disabled')
      eRxButton.addEventListener('click', event => event.preventDefault())

      info.classList.remove('u-hidden')

      getClientSideHook(
        DATA_HOOKS.conventionalPrescriptionInfo
      ).classList.remove('u-hidden')
    }

    if (response.data.hasERxItems) {
      rxButton.classList.add('a-Button--disabled')
      rxButton.addEventListener('click', event => event.preventDefault())

      info.classList.remove('u-hidden')

      document
        .querySelector(
          `[data-clientside-hook="${DATA_HOOKS.ePrescriptionInfo}"]`
        )
        .classList.remove('u-hidden')
    }

    getClientSideHook(DATA_HOOKS.differenceLink)?.addEventListener(
      'click',
      event => event.preventDefault()
    )
  }

  const {
    publicConfig: { tenant },
    pageProperties: { experiments }
  } = store.getPublicRuntimeConfig()

  if (tenant !== TENANT_COM) {
    return
  }

  if (!isSaeOnly(experiments)) {
    clientFockService.fetchUserSessionData().then(renderModal)

    return
  }

  cartService.fetchMetadata().then(renderModal)
}
